import React from "react";
import styles from "../../styles/landing.module.css";

const NotificationsSection = () => {
  return (
    <section className={styles.notificationsSection}>
      <div className={styles.notificationsContent}>
        <div className={styles.notificationsImage}>
          <img 
            src="/notification.png" 
            alt="Smart Notification System" 
            className={styles.sectionImage}
          />
          <p className={styles.imageCaption}>
            Notifications are optimized for your learning style and timing preferences
          </p>
        </div>

        <div className={styles.notificationsText}>
          <h2>Smart Notifications</h2>
          <p>
            Memory Curve reminds you to revise at the ideal moment with a 
            personalized and adaptive notification system.
          </p>
          <ul>
            <li>Notifications via email, browser or mobile app</li>
            <li>Reminders adapted to your personal learning curve</li>
            <li>Smart scheduling based on your study habits</li>
            <li>Automatic adjustments based on your performance</li>
          </ul>
          <p>
            Never miss an important revision session for your long-term memory again!
          </p>
        </div>
      </div>
    </section>
  );
};

export default NotificationsSection; 